module.exports = __webpack_public_path__ + "img/freight_yard1_2.d304d00a.png";